import script from "./EventSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSearch.vue?vue&type=script&setup=true&lang=js"

import "./EventSearch.vue?vue&type=style&index=0&id=2e51a14c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e51a14c"]])

export default __exports__